<button type="button" 
        class="sidebar-btn"
        [attr.data-bs-toggle]="tooltip ? 'tooltip' : null"
        [attr.data-bs-placement]="'right'"
        [attr.title]="tooltip">
  <fa-icon [icon]="icon" size="lg"></fa-icon>
</button>